import fileSizeFormatter from './filters/file-size-formatter';

angular.module('festzelt-os.modules.media', [
    'festzelt-os.components'
]).filter('mediaFormatFileSize', fileSizeFormatter);

require('./routes');

require('./components/al-media-form-field/component.js');
require('./components/al-media-thumbnail/component');
require('./components/al-media-manager/component.js');



// WEBPACK FOOTER //
// ./src/app/modules/media/module.js